export default function disposeLastAccessedOrganization(lastAccessedOrganizationVar) {
    return function () {
        lastAccessedOrganizationVar(null);
        localStorage.removeItem('lastAccessedOrganization');
    };
}
